import moment from "moment";

moment.defaultFormat = "YYYY-MM-DDTHH:mm:ss.SSS";

moment.fn.toJSON = function() {
  return this.format("YYYY-MM-DDTHH:mm:ss.SSS");
};
